import { LanguageIsoCode } from "../../composition-functions/language/LanguageIsoCode";

export type LanguagesRecord<T> = Partial<Record<LanguageIsoCode, T>>;

export function isLanguagesRecord(value: unknown): value is LanguagesRecord<unknown> {
  if (typeof value !== "object" || value === null) return false;
  return Object.keys(value).every((key) => Object.values(LanguageIsoCode).includes(key as LanguageIsoCode));
}